import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Interfaces
import { ComplianceReportCollectionViewResponse } from '../interfaces/compliance-report-collection-view-response.interface';
import { ComplianceReportQueryParams } from '../interfaces/compliance-report-params.interface';

// Services
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

@Injectable({
    providedIn: 'root',
})
export class ComplianceReportService {
    constructor(private readonly ajaxService: AjaxService, private readonly urlsService: UrlsService) {}

    getComplianceReports(params: ComplianceReportQueryParams): Observable<ComplianceReportCollectionViewResponse> {
        const url = this.urlsService.COMPLIANCE.COLLECTION;
        return this.ajaxService.getDataObserveBody(url, params);
    }
}
